export function useIsMobile() {
  const mediaQuery = window.matchMedia('(width < 768px)')
  const isMobile = mediaQuery.matches

  return isMobile
}
